import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MONTHLY_KEYS, planName, quotaLabel } from "@/components/billing/PlanCards";
import { toast } from "sonner";
import { t } from "@/i18n";

export function QuotaDialog() {
  const [info, setInfo] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    const h = (e) => { setInfo(e.detail); setTimeout(() => toast.dismiss(), 50); };
    window.addEventListener("quota:exceeded", h);
    return () => window.removeEventListener("quota:exceeded", h);
  }, []);
  if (!info) return null;
  const go = () => { setInfo(null); nav("/tarifs"); };
  return (
    <Dialog open onOpenChange={(o) => !o && setInfo(null)}>
      <DialogContent data-testid="quota-dialog">
        <DialogHeader>
          <DialogTitle>{t("quota.title")}</DialogTitle>
          <DialogDescription data-testid="quota-dialog-body">
            {t("quota.body", { used: info.used, limit: info.limit, label: quotaLabel(info.kind, info.limit), plan: planName(info.plan) })}
            {MONTHLY_KEYS.includes(info.kind) && <> {t("quota.monthly_reset")}</>}
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm" data-testid="quota-dialog-plan">{t("quota.current_plan")} <strong>{planName(info.plan)}</strong></p>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => setInfo(null)} data-testid="quota-dialog-later">{t("quota.later")}</Button>
          <Button onClick={go} data-testid="quota-dialog-upgrade">{t("quota.upgrade")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
